import buzzHappy from './buzz-happy.svg';
import buzzIdle from './buzz-idle.svg';
import buzzMoving from './buzz-moving.svg';
import buzzNervous from './buzz-nervous.svg';
import buzzSad from './buzz-sad.svg';
import buzzStatic from './buzz-static.svg';
import buzzStressed from './buzz-stressed.svg';
import fizzHappy from './fizz-happy.svg';
import fizzIdle from './fizz-idle.svg';
import fizzMoving from './fizz-moving.svg';
import fizzNervous from './fizz-nervous.svg';
import fizzSad from './fizz-sad.svg';
import fizzStatic from './fizz-static.svg';
import fizzStressed from './fizz-stressed.svg';

export type Character = 'fizz' | 'buzz';

export type Mood =
  | 'idle'
  | 'moving'
  | 'happy'
  | 'sad'
  | 'nervous'
  | 'stressed'
  | 'static';

const TABLE: Record<Character, Record<Mood, string>> = {
  fizz: {
    idle: fizzIdle,
    moving: fizzMoving,
    happy: fizzHappy,
    sad: fizzSad,
    nervous: fizzNervous,
    stressed: fizzStressed,
    static: fizzStatic,
  },
  buzz: {
    idle: buzzIdle,
    moving: buzzMoving,
    happy: buzzHappy,
    sad: buzzSad,
    nervous: buzzNervous,
    stressed: buzzStressed,
    static: buzzStatic,
  },
};

export function getAvatar(character: Character, mood: Mood): string {
  return TABLE[character][mood];
}

export const AVATAR_PREVIEW: Record<Character, string> = {
  fizz: fizzIdle,
  buzz: buzzIdle,
};
